import { useLocation, useNavigate } from "react-router-dom";

const FlaskIcon = ({ className }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <path d="M12.6 30h22.8l4.6 9.2A2.2 2.2 0 0 1 38 42.5H10a2.2 2.2 0 0 1-2-3.3z" fill="url(#fchem-liquid)" />
    <path d="M17 5h14M20 5v12.5L8.4 38.6A4 4 0 0 0 12 44.5h24a4 4 0 0 0 3.6-5.9L28 17.5V5" stroke="#4ADE80" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    <defs>
      <linearGradient id="fchem-liquid" x1="0" y1="30" x2="0" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4ADE80" stopOpacity="0.9" /><stop offset="1" stopColor="#16A34A" stopOpacity="0.9" />
      </linearGradient>
    </defs>
  </svg>
);

export const Logo = ({ size = "md" }) => {
  const big = size === "lg";
  const navigate = useNavigate();
  const location = useLocation();
  const back = () => (location.key !== "default" ? navigate(-1) : navigate("/"));
  return (
    <button type="button" onClick={back} title="Geri dön" aria-label="FChem – geri dön" className="flex items-center gap-3 select-none logo-wrap cursor-pointer hover:opacity-90 transition-opacity duration-150" data-testid="fchem-logo">
      <span className={`${big ? "h-14 w-14 rounded-2xl" : "h-11 w-11 rounded-xl"} grid place-items-center border border-[#22C55E]/40 bg-gradient-to-br from-[#22C55E]/25 to-[#0B0F16] shadow-[0_0_24px_-4px_rgba(34,197,94,0.6),inset_0_1px_0_rgba(255,255,255,0.08)]`}>
        <FlaskIcon className={big ? "h-9 w-9" : "h-7 w-7"} />
      </span>
      <span className={`${big ? "text-5xl" : "text-3xl"} font-display font-bold leading-none logo-text`}>FChem</span>
    </button>
  );
};
